// extracted by mini-css-extract-plugin
var _1 = "dTBpK84AJmUIXIIs5iIP";
var _2 = "T8VibEkeQAHcQnDWU6Z5";
var _3 = "SLekGIQjmGGLzFbTPEed";
var _4 = "WzoZUgvVJqF9wRoTkZUQ";
var _5 = "Y0Oftdi8FOHQSGI9Uy6d";
var _6 = "B5GtouktJkYTV2eJa7bl";
var _7 = "s1xDTPirvn6Phgmv5yZ_";
var _8 = "YiFhw_3Uqa3LMEdjO_Zd";
var _9 = "rmkgC6IBv_1DxrzG1YWK";
var _a = "L8nRqltZJTqL6p1ZMIFQ";
export { _1 as "backgroundGradient", _2 as "backgroundImage", _3 as "children", _4 as "contentWrapper", _5 as "heading", _6 as "icon", _7 as "logo", _8 as "message", _9 as "outdated", _a as "wrapper" }
